/**
 * NotBuiltYet — the one placeholder for a planned, not yet built, section
 * (docs/features/order-to-invoice/16_frontend_followup_spec.md §3.2): one
 * plain line saying what is missing, when, and whose it is. Nothing here
 * links, colours or collects feedback.
 *
 * It renders only while the `previews` feature is on (dev and staging), so in
 * production a planned section is simply absent. `planned` is a manifest id,
 * which the type checks and `scripts/check-planned-sections.mjs` requires to
 * be a string literal at every use.
 */
import { isFeatureEnabled } from "@shared-core/config/features";
import {
  plannedSectionById,
  type PlannedSectionId,
} from "@shared-core/domain/planned-sections";

export function NotBuiltYet({ planned }: { planned: PlannedSectionId }) {
  if (!isFeatureEnabled("previews")) return null;
  const { label, step, stream } = plannedSectionById(planned);
  return (
    <p data-section-id={planned} className="text-sm text-muted-foreground">
      Not built yet · {label} · {step} · {stream}
    </p>
  );
}
